import { SunSnowflakeIcon } from './SunSnowflakeIcon';

/**
 * author: Google
 * id 2294E545-CE17-4605-8DBD-FFAE9CFDFED6
 * name sun-snowflake
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-snowflake.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const HeatCoolIcon = SunSnowflakeIcon;
export default HeatCoolIcon